import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MainService } from '../../service/main.service';
import { ActivatedRoute } from '@angular/router';
import { ToasterServiceService } from '../../service/toaster.service';
import { Location } from '@angular/common';
import { LocalStorageService } from '../../service/local-storage.service';
import { ApiUrls } from '../../apiRouts';
@Component({
  selector: 'app-add-edit-event',
  templateUrl: './add-edit-event.component.html',
  styleUrl: './add-edit-event.component.scss'
})
export class AddEditEventComponent {
  eventForm: any = FormGroup;
  submitted = false;
  action: any;
  userId: any;
  editEventData: any;

  constructor(
    private location: Location,
    private fb: FormBuilder,
    private mainService: MainService,
    private route: ActivatedRoute,
    private toasterService: ToasterServiceService,
    private localStorageService: LocalStorageService
  ) {
    this.userId = JSON.parse(this.localStorageService.getItem("loginData") || '{}').user_id;
    this.route.params.subscribe((params: any) => {
      this.action = params['action'] || '';
    });
    this.eventForm = this.fb.group({
      event_name: ['', [Validators.required]],
    })
    if (this.action == 'Edit') {
      this.editEventData = this.mainService.selectEventData;
      this.eventForm.patchValue(this.editEventData);
    }
  }

  get f() {
    return this.eventForm.controls;
  }

  goBackToPrevPage() {
    this.location.back();
  }

  submit() {
    this.submitted = true;
    if (this.eventForm.valid) {
      if (this.action == 'Edit') {
        var data: any = {
          event_id: this.editEventData.event_id,
          event_name: this.eventForm.value.event_name,
          created_by: this.userId,
          is_active: '',
          created_person_name: '',
          Action: 'UPDATE'
        }
        this.mainService.postApi(ApiUrls.addEvent, data, 1).subscribe(res => {
          if (res.status == 1) {
            this.toasterService.toastSuccess(res.response);
            this.location.back();
          } else {
            this.toasterService.toastSuccess(res.response);
          }
        })
      } else {
        var data: any = {
          event_id: 0,
          event_name: this.eventForm.value.event_name,
          created_by: this.userId,
          is_active: '',
          created_person_name: '',
          Action: 'INSERT'
        }
        this.mainService.postApi(ApiUrls.addEvent, data, 1).subscribe(res => {
          if (res.status == 1) {
            this.toasterService.toastSuccess(res.response);
            this.location.back();
          } else {
            this.toasterService.toastSuccess(res.response);
          }
        })
      }
    }
  }
}
